var Opal = require('../opal').default; /* Generated by Opal 0.11.99.dev */
Opal.modules["diceBot/EarthDawn"] = function(Opal) {
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy, $gvars = Opal.gvars;

  Opal.add_stubs(['$setPrefixes', '$ed_step', '$getStepResult', '$=~', '$to_i', '$>', '$<', '$getStepTable', '$[]', '$-', '$===', '$+', '$debug', '$rollStep', '$!=', '$==', '$>=', '$empty?', '$times', '$roll']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'EarthDawn');

    var $nesting = [self].concat($parent_nesting), $EarthDawn_initialize$1, $EarthDawn_gameName$2, $EarthDawn_gameType$3, $EarthDawn_getHelpMessage$4, $EarthDawn_rollDiceCommand$5, $EarthDawn_ed_step$6, $EarthDawn_getStepResult$7, $EarthDawn_getStepTable$8, $EarthDawn_rollStep$9;

    self.$$prototype.string = self.$$prototype.isFailed = nil;
    
    self.$setPrefixes(["\\d+e.*"]);
    
    Opal.def(self, '$initialize', $EarthDawn_initialize$1 = function $$initialize() {
      var $iter = $EarthDawn_initialize$1.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

      if ($iter) $EarthDawn_initialize$1.$$p = null;
      // Prepare super implicit arguments
      for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
        $zuper[$zuper_i] = arguments[$zuper_i];
      }
      
      $send(self, Opal.find_super_dispatcher(self, 'initialize', $EarthDawn_initialize$1, false), $zuper, $iter);
      self.sendMode = 2;
      return (self.sortType = 1);
    }, $EarthDawn_initialize$1.$$arity = 0);
    
    Opal.def(self, '$gameName', $EarthDawn_gameName$2 = function $$gameName() {
      var self = this;

      return "アースドーン"
    }, $EarthDawn_gameName$2.$$arity = 0);
    
    Opal.def(self, '$gameType', $EarthDawn_gameType$3 = function $$gameType() {
      var self = this;

      return "EarthDawn"
    }, $EarthDawn_gameType$3.$$arity = 0);
    
    Opal.def(self, '$getHelpMessage', $EarthDawn_getHelpMessage$4 = function $$getHelpMessage() {
      var self = this;

      return "" + "ステップダイス　(xEn+k)\n" + "ステップx、目標値n(省略可能）、カルマダイスk(D2-D20)でステップダイスをロールします。\n" + "振り足しも自動。\n" + "例）9E　10E8　10E+D12\n"
    }, $EarthDawn_getHelpMessage$4.$$arity = 0);
    
    Opal.def(self, '$rollDiceCommand', $EarthDawn_rollDiceCommand$5 = function $$rollDiceCommand(command) {
      var self = this;

      return self.$ed_step(command)
    }, $EarthDawn_rollDiceCommand$5.$$arity = 1);
    
    Opal.def(self, '$ed_step', $EarthDawn_ed_step$6 = function $$ed_step(str) {
      var self = this, output = nil;

      
      output = self.$getStepResult(str);
      return output;
    }, $EarthDawn_ed_step$6.$$arity = 1);
    
    Opal.def(self, '$getStepResult', $EarthDawn_getStepResult$7 = function $$getStepResult(str) {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, stepTotal = nil, step2 = nil, step = nil, targetNumber = nil, hasKarmaDice = nil, karmaDiceCount = nil, karmaDiceType = nil, stable = nil, nmod = nil, d20step = nil, d12step = nil, d10step = nil, d8step = nil, d6step = nil, d4step = nil, $case = nil, output = nil, excelentSuccessNumber = nil, superSuccessNumber = nil, goodSuccessNumber = nil, failedNumber = nil;

      
      if ($truthy(/(\d+)E(\d+)?(\+)?(\d+)?(d\d+)?/i['$=~'](str))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      stepTotal = 0;
      self.isFailed = true;
      step2 = 0;
      step = __last__match__1.$to_i();
      targetNumber = 0;
      hasKarmaDice = false;
      karmaDiceCount = 0;
      karmaDiceType = 0;
      if ($truthy($rb_gt(step, 40))) {
        
        step2 = step;
        step = 40;};
      if ($truthy(__last__match__2)) {
        
        targetNumber = __last__match__2.$to_i();
        if ($truthy($rb_gt(targetNumber, 43))) {
          targetNumber = 42};};
      if ($truthy(__last__match__3)) {
        hasKarmaDice = __last__match__3.$to_i()};
      if ($truthy(__last__match__4)) {
        karmaDiceCount = __last__match__4.$to_i()};
      if ($truthy(__last__match__5)) {
        karmaDiceType = __last__match__5};
      if ($truthy($rb_lt(targetNumber, 0))) {
        return nil};
      stable = self.$getStepTable();
      nmod = stable['$[]'](0)['$[]']($rb_minus(step, 1));
      d20step = stable['$[]'](1)['$[]']($rb_minus(step, 1));
      d12step = stable['$[]'](2)['$[]']($rb_minus(step, 1));
      d10step = stable['$[]'](3)['$[]']($rb_minus(step, 1));
      d8step = stable['$[]'](4)['$[]']($rb_minus(step, 1));
      d6step = stable['$[]'](5)['$[]']($rb_minus(step, 1));
      d4step = stable['$[]'](6)['$[]']($rb_minus(step, 1));
      if ($truthy(hasKarmaDice)) {
        $case = karmaDiceType;
        if (/d20/i['$===']($case)) {
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        d20step = $rb_plus(d20step, karmaDiceCount);}
        else if (/d12/i['$===']($case)) {
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        d12step = $rb_plus(d12step, karmaDiceCount);}
        else if (/d10/i['$===']($case)) {
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        d10step = $rb_plus(d10step, karmaDiceCount);}
        else if (/d8/i['$===']($case)) {
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        d8step = $rb_plus(d8step, karmaDiceCount);}
        else if (/d6/i['$===']($case)) {
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        d6step = $rb_plus(d6step, karmaDiceCount);}
        else if (/d4/i['$===']($case)) {
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        d4step = $rb_plus(d4step, karmaDiceCount);}
        else {nmod = $rb_plus(nmod, karmaDiceCount)}};
      self.string = "";
      self.$debug("d20step, d12step, d10step, d8step, d6step, d4step", d20step, d12step, d10step, d8step, d6step, d4step);
      stepTotal = $rb_plus(stepTotal, self.$rollStep(20, d20step));
      stepTotal = $rb_plus(stepTotal, self.$rollStep(12, d12step));
      stepTotal = $rb_plus(stepTotal, self.$rollStep(10, d10step));
      stepTotal = $rb_plus(stepTotal, self.$rollStep(8, d8step));
      stepTotal = $rb_plus(stepTotal, self.$rollStep(6, d6step));
      stepTotal = $rb_plus(stepTotal, self.$rollStep(4, d4step));
      if ($truthy($rb_gt(nmod, 0))) {
        self.string = $rb_plus(self.string, "+")};
      if ($truthy(nmod['$!='](0))) {
        
        self.string = $rb_plus(self.string, "" + (nmod));
        stepTotal = $rb_plus(stepTotal, nmod);};
      self.string = $rb_plus(self.string, "" + " ＞ " + (stepTotal));
      output = "" + "ステップ" + (step) + " ＞ " + (self.string);
      if ($truthy(targetNumber['$=='](0))) {
        return output};
      self.string = $rb_plus(self.string, " ＞ ");
      excelentSuccessNumber = stable['$[]'](7)['$[]']($rb_minus(targetNumber, 1));
      superSuccessNumber = stable['$[]'](8)['$[]']($rb_minus(targetNumber, 1));
      goodSuccessNumber = stable['$[]'](9)['$[]']($rb_minus(targetNumber, 1));
      failedNumber = stable['$[]'](11)['$[]']($rb_minus(targetNumber, 1));
      if ($truthy(self.isFailed)) {
        self.string = $rb_plus(self.string, "自動失敗")
      } else if ($truthy($rb_ge(stepTotal, excelentSuccessNumber))) {
        self.string = $rb_plus(self.string, "最良成功")
      } else if ($truthy($rb_ge(stepTotal, superSuccessNumber))) {
        self.string = $rb_plus(self.string, "優成功")
      } else if ($truthy($rb_ge(stepTotal, goodSuccessNumber))) {
        self.string = $rb_plus(self.string, "良成功")
      } else if ($truthy($rb_ge(stepTotal, targetNumber))) {
        self.string = $rb_plus(self.string, "成功")
      } else if ($truthy($rb_lt(stepTotal, failedNumber))) {
        self.string = $rb_plus(self.string, "大失敗")
      } else {
        self.string = $rb_plus(self.string, "失敗")
      };
      output = "" + "ステップ" + (step) + ">=" + (targetNumber) + " ＞ " + (self.string);
      return output;
    }, $EarthDawn_getStepResult$7.$$arity = 1);
    
    Opal.def(self, '$getStepTable', $EarthDawn_getStepTable$8 = function $$getStepTable() {
      var self = this, mod = nil, d20 = nil, d12 = nil, d10 = nil, d8 = nil, d6 = nil, d4 = nil, exsuc = nil, ssuc = nil, gsuc = nil, nsuc = nil, fsuc = nil, stable = nil;

      
      mod = [-2, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      d20 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      d12 = [0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
      d10 = [0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 1, 2, 1, 0, 0, 0, 1, 0, 0, 0, 1, 1, 2, 1, 1, 1, 1, 2, 1, 1, 1, 2, 3, 2, 1, 1, 1, 2, 1, 1, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 1, 2, 1];
      d8 = [0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 1, 1, 2, 1, 1, 1, 2, 2, 1, 1, 1, 1, 2, 1, 1, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0];
      d6 = [0, 0, 0, 1, 0, 0, 0, 2, 1, 1, 0, 0, 0, 0, 1, 0, 0, 0, 2, 1, 1, 0, 0, 0, 0, 1, 0, 0, 0, 2, 1, 0, 0, 0, 0, 1, 0, 0, 0, 2, 0, 0, 0, 0, 1, 0, 0, 0, 2, 1, 1, 0, 0, 0];
      d4 = [1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      exsuc = [6, 8, 10, 12, 14, 17, 19, 20, 22, 24, 25, 27, 29, 32, 33, 35, 37, 38, 39, 41, 42, 44, 45, 47, 48, 49, 51, 52, 54, 55, 56, 58, 59, 60, 62, 64, 65, 67, 68, 70, 71, 72];
      ssuc = [4, 6, 8, 10, 11, 13, 15, 16, 18, 19, 21, 22, 24, 26, 27, 29, 30, 32, 33, 34, 35, 37, 38, 40, 41, 42, 43, 45, 46, 47, 48, 49, 51, 52, 53, 55, 56, 58, 59, 60, 61, 62];
      gsuc = [2, 4, 6, 7, 9, 10, 12, 13, 14, 15, 17, 18, 20, 21, 22, 24, 25, 26, 27, 28, 29, 31, 32, 33, 34, 35, 36, 38, 39, 40, 41, 42, 43, 45, 46, 47, 48, 50, 51, 52, 53, 54];
      nsuc = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42];
      fsuc = [0, 1, 1, 1, 1, 2, 2, 3, 4, 5, 5, 6, 6, 7, 8, 8, 9, 10, 11, 12, 13, 13, 14, 15, 16, 17, 18, 18, 18, 20, 21, 22, 23, 23, 24, 25, 26, 26, 27, 28, 29, 30];
      stable = [mod, d20, d12, d10, d8, d6, d4, exsuc, ssuc, gsuc, nsuc, fsuc];
      return stable;
    }, $EarthDawn_getStepTable$8.$$arity = 0);
    return (Opal.def(self, '$rollStep', $EarthDawn_rollStep$9 = function $$rollStep(diceType, diceCount) {
      var $$10, self = this, stepTotal = nil;

      
      self.$debug("rollStep diceType, diceCount, @string", diceType, diceCount, self.string);
      stepTotal = 0;
      if ($truthy($rb_gt(diceCount, 0))) {
      } else {
        return stepTotal
      };
      if ($truthy(self.string['$empty?']())) {
      } else {
        self.string = $rb_plus(self.string, "+")
      };
      self.string = $rb_plus(self.string, "" + (diceCount) + "d" + (diceType) + "[");
      self.$debug("rollStep @string", self.string);
      $send(diceCount, 'times', [], ($$10 = function(i){var self = $$10.$$s || this, $a, $b, $c, dice_now = nil, dummy = nil, dice_in = nil;
        if (self.string == null) self.string = nil;

      
        
        if (i == null) {
          i = nil;
        };
        $b = self.$roll(1, diceType), $a = Opal.to_ary($b), (dice_now = ($a[0] == null ? nil : $a[0])), (dummy = ($a[1] == null ? nil : $a[1])), $b;
        if ($truthy(dice_now['$!='](1))) {
          self.isFailed = false};
        dice_in = dice_now;
        while ($truthy(dice_now['$=='](diceType))) {
          
          $c = self.$roll(1, diceType), $b = Opal.to_ary($c), (dice_now = ($b[0] == null ? nil : $b[0])), (dummy = ($b[1] == null ? nil : $b[1])), $c;
          dice_in = $rb_plus(dice_in, dice_now);
        };
        stepTotal = $rb_plus(stepTotal, dice_in);
        if ($truthy(i['$!='](0))) {
          self.string = $rb_plus(self.string, ",")};
        return (self.string = $rb_plus(self.string, "" + (dice_in)));}, $$10.$$s = self, $$10.$$arity = 1, $$10));
      self.string = $rb_plus(self.string, "]");
      return stepTotal;
    }, $EarthDawn_rollStep$9.$$arity = 2), nil) && 'rollStep';
  })($nesting[0], $$($nesting, 'DiceBot'), $nesting)
};

/* Generated by Opal 0.11.99.dev */
(function(Opal) {
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_divide(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs / rhs : lhs['$/'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy, $gvars = Opal.gvars;

  Opal.add_stubs(['$require', '$setPrefixes', '$ed_step', '$getStepResult', '$getStepResultInfos', '$nil?', '$==', '$getSuccess', '$!', '$empty?', '$debug', '$getStepResultInfo', '$<<', '$join', '$inject', '$+', '$>', '$size', '$=~', '$to_i', '$<', '$getStepInfo', '$each', '$rollStep', '$shift', '$getModifyText', '$getBaseStepTable', '$first', '$last', '$<=', '$get_table_by_number', '$-', '$/', '$times', '$addStepToResult', '$%', '$[]', '$[]=', '$roll', '$!=']);
  
  self.$require("diceBot/EarthDawn");
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'EarthDawn4');

    var $nesting = [self].concat($parent_nesting), $EarthDawn4_initialize$1, $EarthDawn4_gameName$2, $EarthDawn4_gameType$3, $EarthDawn4_getHelpMessage$4, $EarthDawn4_rollDiceCommand$5, $EarthDawn4_ed_step$6, $EarthDawn4_getStepResult$7, $EarthDawn4_getStepResultInfos$8, $EarthDawn4_getStepResultInfo$10, $EarthDawn4_getModifyText$12, $EarthDawn4_getBaseStepTable$13, $EarthDawn4_getStepInfo$14, $EarthDawn4_addStepToResult$16, $EarthDawn4_getSuccess$18, $EarthDawn4_rollStep$19;

    self.$$prototype.calcText = self.$$prototype.isFailed = nil;
    
    self.$setPrefixes(["\\d+e.*"]);
    
    Opal.def(self, '$initialize', $EarthDawn4_initialize$1 = function $$initialize() {
      var $iter = $EarthDawn4_initialize$1.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

      if ($iter) $EarthDawn4_initialize$1.$$p = null;
      // Prepare super implicit arguments
      for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
        $zuper[$zuper_i] = arguments[$zuper_i];
      }
      
      $send(self, Opal.find_super_dispatcher(self, 'initialize', $EarthDawn4_initialize$1, false), $zuper, $iter);
      self.sendMode = 2;
      self.sortType = 1;
      return (self.calcText = "");
    }, $EarthDawn4_initialize$1.$$arity = 0);
    
    Opal.def(self, '$gameName', $EarthDawn4_gameName$2 = function $$gameName() {
      var self = this;

      return "アースドーン4版"
    }, $EarthDawn4_gameName$2.$$arity = 0);
    
    Opal.def(self, '$gameType', $EarthDawn4_gameType$3 = function $$gameType() {
      var self = this;

      return "EarthDawn4"
    }, $EarthDawn4_gameType$3.$$arity = 0);
    
    Opal.def(self, '$getHelpMessage', $EarthDawn4_getHelpMessage$4 = function $$getHelpMessage() {
      var self = this;

      return "" + "ステップダイス　(xEnK)\n" + "ステップx、目標値n(省略可能）でステップダイスをロール。\n" + "カルマダイス使用時は末尾にKを追加（省略可能）\n" + "例）ステップ10：10E\n" + "　　ステップ10、目標値8：10E8\n" + "　　ステップ10、目標値8、カルマダイス：10E8K\n"
    }, $EarthDawn4_getHelpMessage$4.$$arity = 0);
    
    Opal.def(self, '$rollDiceCommand', $EarthDawn4_rollDiceCommand$5 = function $$rollDiceCommand(command) {
      var self = this;

      return self.$ed_step(command)
    }, $EarthDawn4_rollDiceCommand$5.$$arity = 1);
    
    Opal.def(self, '$ed_step', $EarthDawn4_ed_step$6 = function $$ed_step(str) {
      var self = this, output = nil;

      
      output = self.$getStepResult(str);
      return output;
    }, $EarthDawn4_ed_step$6.$$arity = 1);
    
    Opal.def(self, '$getStepResult', $EarthDawn4_getStepResult$7 = function $$getStepResult(str) {
      var $a, $b, self = this, stepText = nil, calcText = nil, stepTotal = nil, targetNumber = nil, output = nil, successText = nil;

      
      $b = self.$getStepResultInfos(str), $a = Opal.to_ary($b), (stepText = ($a[0] == null ? nil : $a[0])), (calcText = ($a[1] == null ? nil : $a[1])), (stepTotal = ($a[2] == null ? nil : $a[2])), (targetNumber = ($a[3] == null ? nil : $a[3])), $b;
      if ($truthy(stepText['$nil?']())) {
        return nil};
      if ($truthy(targetNumber['$=='](0))) {
        
        output = "" + (stepText) + " ＞ " + (calcText) + " ＞ " + (stepTotal);
        return output;};
      successText = self.$getSuccess(targetNumber, stepTotal);
      output = "" + (stepText) + ">=" + (targetNumber) + " ＞ " + (calcText) + " ＞ " + (stepTotal) + " ＞ " + (successText);
      return output;
    }, $EarthDawn4_getStepResult$7.$$arity = 1);
    
    Opal.def(self, '$getStepResultInfos', $EarthDawn4_getStepResultInfos$8 = function $$getStepResultInfos(str) {
      var $a, $b, $c, $$9, self = this, steps = nil, calcs = nil, totals = nil, target = nil, step = nil, calc = nil, total = nil, value = nil, nextText = nil, stepText = nil, calcText = nil, stepTotal = nil;

      
      steps = [];
      calcs = [];
      totals = [];
      target = 0;
      while ($truthy(($truthy($b = str['$nil?']()['$!']()) ? str['$empty?']()['$!']() : $b))) {
        
        self.$debug("=====>!! str", str);
        $c = self.$getStepResultInfo(str), $b = Opal.to_ary($c), (step = ($b[0] == null ? nil : $b[0])), (calc = ($b[1] == null ? nil : $b[1])), (total = ($b[2] == null ? nil : $b[2])), (value = ($b[3] == null ? nil : $b[3])), (nextText = ($b[4] == null ? nil : $b[4])), $c;
        self.$debug("=====> step", step);
        if ($truthy(step['$nil?']())) {
          return nil};
        steps['$<<'](step);
        calcs['$<<'](calc);
        totals['$<<'](total);
        if (value['$=='](0)) {
        } else {
          target = value
        };
        self.$debug("=====> nextText", nextText);
        if (nextText['$=='](str)) {
          break;};
        str = nextText;
      };
      stepText = steps.$join("+");
      calcText = calcs.$join(")+(");
      stepTotal = $send(totals, 'inject', [], ($$9 = function(sum, i){var self = $$9.$$s || this;

      
        
        if (sum == null) {
          sum = nil;
        };
        
        if (i == null) {
          i = nil;
        };
        return $rb_plus(sum, i);}, $$9.$$s = self, $$9.$$arity = 2, $$9));
      if ($truthy($rb_gt(calcs.$size(), 1))) {
        calcText = $rb_plus($rb_plus("(", calcText), ")")};
      if ($truthy($rb_gt(totals.$size(), 1))) {
        calcText = $rb_plus(calcText, "" + " ＞ (" + (totals.$join("+")) + ")")};
      return [stepText, calcText, stepTotal, target];
    }, $EarthDawn4_getStepResultInfos$8.$$arity = 1);
    
    Opal.def(self, '$getStepResultInfo', $EarthDawn4_getStepResultInfo$10 = function $$getStepResultInfo(str) {
      var $a, $$11, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, stepTotal = nil, step = nil, targetNumber = nil, hasKarmaDice = nil, diceModify = nil, nextText = nil, stepInfo = nil, diceTypes = nil, modify = nil, stepText = nil;

      
      if ($truthy(/^(\d+)E(\d+)?(K)?(\+\d+$)?(\+(.*))?/i['$=~'](str))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      stepTotal = 0;
      self.isFailed = true;
      step = __last__match__1.$to_i();
      targetNumber = __last__match__2.$to_i();
      if ($truthy($rb_lt(targetNumber, 0))) {
        return nil};
      hasKarmaDice = __last__match__3['$nil?']()['$!']();
      diceModify = __last__match__4.$to_i();
      nextText = __last__match__6;
      stepInfo = self.$getStepInfo(step);
      self.$debug("stepInfo", stepInfo);
      self.calcText = "";
      diceTypes = [20, 12, 10, 8, 6, 4];
      $send(diceTypes, 'each', [], ($$11 = function(type){var self = $$11.$$s || this;

      
        
        if (type == null) {
          type = nil;
        };
        return (stepTotal = $rb_plus(stepTotal, self.$rollStep(type, stepInfo.$shift())));}, $$11.$$s = self, $$11.$$arity = 1, $$11));
      modify = stepInfo.$shift();
      if ($truthy(hasKarmaDice)) {
        stepTotal = $rb_plus(stepTotal, self.$rollStep(6, 1))};
      self.calcText = $rb_plus(self.calcText, $rb_plus(self.$getModifyText(modify), self.$getModifyText(diceModify)));
      stepTotal = $rb_plus(stepTotal, $rb_plus(modify, diceModify));
      stepText = "" + "ステップ" + (step);
      return [stepText, self.calcText, stepTotal, targetNumber, nextText];
    }, $EarthDawn4_getStepResultInfo$10.$$arity = 1);
    
    Opal.def(self, '$getModifyText', $EarthDawn4_getModifyText$12 = function $$getModifyText(modify) {
      var self = this, string = nil;

      
      string = "";
      if ($truthy(modify['$=='](0))) {
        return string};
      if ($truthy($rb_gt(modify, 0))) {
        string = $rb_plus(string, "+")};
      string = $rb_plus(string, "" + (modify));
      return string;
    }, $EarthDawn4_getModifyText$12.$$arity = 1);
    
    Opal.def(self, '$getBaseStepTable', $EarthDawn4_getBaseStepTable$13 = function $$getBaseStepTable() {
      var self = this, stepTable = nil;

      
      stepTable = [[1, [0, 0, 0, 0, 0, 1, -2]], [2, [0, 0, 0, 0, 0, 1, -1]], [3, [0, 0, 0, 0, 0, 1, 0]], [4, [0, 0, 0, 0, 1, 0, 0]], [5, [0, 0, 0, 1, 0, 0, 0]], [6, [0, 0, 1, 0, 0, 0, 0]], [7, [0, 1, 0, 0, 0, 0, 0]]];
      return stepTable;
    }, $EarthDawn4_getBaseStepTable$13.$$arity = 0);
    
    Opal.def(self, '$getStepInfo', $EarthDawn4_getStepInfo$14 = function $$getStepInfo(step) {
      var $$15, self = this, baseStepTable = nil, baseMaxStep = nil, overBounusStep = nil, overStep = nil, stepRythm = nil, result = nil, loopCount = nil, index = nil, restStepInfo = nil;

      
      baseStepTable = self.$getBaseStepTable();
      baseMaxStep = baseStepTable.$last().$first();
      if ($truthy($rb_le(step, baseMaxStep))) {
        return self.$get_table_by_number(step, baseStepTable)};
      overBounusStep = [1, 0, 0, 0, 0, 0, 0];
      overStep = $rb_minus($rb_minus(step, baseMaxStep), 1);
      stepRythm = [[0, 0, 0, 0, 2, 0, 0], [0, 0, 0, 1, 1, 0, 0], [0, 0, 0, 2, 0, 0, 0], [0, 0, 1, 1, 0, 0, 0], [0, 0, 2, 0, 0, 0, 0], [0, 1, 1, 0, 0, 0, 0], [0, 2, 0, 0, 0, 0, 0], [0, 1, 0, 0, 2, 0, 0], [0, 1, 0, 1, 1, 0, 0], [0, 1, 0, 2, 0, 0, 0], [0, 1, 1, 1, 0, 0, 0]];
      result = [0, 0, 0, 0, 0, 0, 0];
      loopCount = $rb_divide(overStep, stepRythm.$size());
      $send(loopCount, 'times', [], ($$15 = function(){var self = $$15.$$s || this;

      return self.$addStepToResult(result, overBounusStep)}, $$15.$$s = self, $$15.$$arity = 0, $$15));
      index = overStep['$%'](stepRythm.$size());
      restStepInfo = stepRythm['$[]'](index);
      self.$addStepToResult(result, restStepInfo);
      return result;
    }, $EarthDawn4_getStepInfo$14.$$arity = 1);
    
    Opal.def(self, '$addStepToResult', $EarthDawn4_addStepToResult$16 = function $$addStepToResult(result, step) {
      var $$17, self = this;

      
      $send(result.$size(), 'times', [], ($$17 = function(i){var self = $$17.$$s || this, $writer = nil;

      
        
        if (i == null) {
          i = nil;
        };
        $writer = [i, $rb_plus(result['$[]'](i), step['$[]'](i))];
        $send(result, '[]=', Opal.to_a($writer));
        return $writer[$rb_minus($writer["length"], 1)];}, $$17.$$s = self, $$17.$$arity = 1, $$17));
      return result;
    }, $EarthDawn4_addStepToResult$16.$$arity = 2);
    
    Opal.def(self, '$getSuccess', $EarthDawn4_getSuccess$18 = function $$getSuccess(targetNumber, stepTotal) {
      var self = this, diff = nil, level = nil;

      
      if ($truthy(self.isFailed)) {
        return "自動失敗"};
      diff = $rb_minus(stepTotal, targetNumber);
      self.$debug("diff", diff);
      if ($truthy($rb_lt(diff, 0))) {
        return "失敗"};
      level = $rb_plus($rb_divide(diff, 5), 1);
      return "" + "成功 レベル：" + (level);
    }, $EarthDawn4_getSuccess$18.$$arity = 2);
    return (Opal.def(self, '$rollStep', $EarthDawn4_rollStep$19 = function $$rollStep(diceType, diceCount) {
      var $$20, self = this, stepTotal = nil;

      
      self.$debug("rollStep diceType, diceCount, @calcText", diceType, diceCount, self.calcText);
      stepTotal = 0;
      if ($truthy($rb_gt(diceCount, 0))) {
      } else {
        return stepTotal
      };
      if ($truthy(self.calcText['$empty?']())) {
      } else {
        self.calcText = $rb_plus(self.calcText, "+")
      };
      self.calcText = $rb_plus(self.calcText, "" + (diceCount) + "d" + (diceType) + "[");
      self.$debug("rollStep string", self.calcText);
      $send(diceCount, 'times', [], ($$20 = function(i){var self = $$20.$$s || this, $a, $b, $c, dice_now = nil, dummy = nil, dice_in = nil;
        if (self.calcText == null) self.calcText = nil;

      
        
        if (i == null) {
          i = nil;
        };
        $b = self.$roll(1, diceType), $a = Opal.to_ary($b), (dice_now = ($a[0] == null ? nil : $a[0])), (dummy = ($a[1] == null ? nil : $a[1])), $b;
        if ($truthy(dice_now['$!='](1))) {
          self.isFailed = false};
        dice_in = dice_now;
        while ($truthy(dice_now['$=='](diceType))) {
          
          $c = self.$roll(1, diceType), $b = Opal.to_ary($c), (dice_now = ($b[0] == null ? nil : $b[0])), (dummy = ($b[1] == null ? nil : $b[1])), $c;
          dice_in = $rb_plus(dice_in, dice_now);
        };
        stepTotal = $rb_plus(stepTotal, dice_in);
        if ($truthy(i['$!='](0))) {
          self.calcText = $rb_plus(self.calcText, ",")};
        return (self.calcText = $rb_plus(self.calcText, "" + (dice_in)));}, $$20.$$s = self, $$20.$$arity = 1, $$20));
      self.calcText = $rb_plus(self.calcText, "]");
      return stepTotal;
    }, $EarthDawn4_rollStep$19.$$arity = 2), nil) && 'rollStep';
  })($nesting[0], $$($nesting, 'EarthDawn'), $nesting);
})(Opal);
